import { type ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { readAccessToken } from "../lib/auth";

/** Redirects to /login when no access token is present. The login
 *  page reads the ``from`` location and redirects back after a
 *  successful auth so deep-links survive an unauth interrupt. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const location = useLocation();
  const token = readAccessToken();
  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <>{children}</>;
}
